import React, {FC} from 'react'
import {Link, useLocation, useNavigate} from 'react-router-dom'
import {Topbar} from './Topbar'

const DefaultTitle: FC<{title: string} & any> = ({title, filter, setFilter}) => {
  const location = useLocation()
  const navigate = useNavigate()
  return (
    <div id='kt_app_toolbar' className='app-toolbar py-3 py-lg-6'>
      {/*begin::Toolbar container*/}
      <div id='kt_app_toolbar_container' className='app-container container-xxl d-flex flex-stack'>
        {/*begin::Page title*/}
        <div className='page-title d-flex flex-column justify-content-center flex-wrap me-3'>
          {/*begin::Title*/}
          <h1 className='page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0'>
            {title}
          </h1>
          {/*end::Title*/}
          {/*begin::Breadcrumb*/}
          <ul className='breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1'>
            {/*begin::Item*/}
            <li className='breadcrumb-item text-muted'>
              <Link
                to={'/' + location.pathname.split('/')[1]}
                className='text-muted text-hover-primary'
              >
                Home
              </Link>
            </li>
            {/*end::Item*/}
            {/*begin::Item*/}
            <li className='breadcrumb-item'>
              <span className='bullet bg-gray-400 w-5px h-2px'></span>
            </li>
            {/*end::Item*/}
            {/*begin::Item*/}
            <li className='breadcrumb-item text-muted'>{title}</li>
            {/*end::Item*/}
          </ul>
          {/*end::Breadcrumb*/}
        </div>
        {/*end::Page title*/}
        {/*begin::Actions*/}
        <div className='d-flex align-items-center gap-2 gap-lg-3'>
          <Topbar filter={filter} setFilter={setFilter} />
          {/*begin::Secondary button*/}
          <button
            onClick={() => navigate(-1)}
            className='btn btn-sm fw-bold bg-body btn-color-gray-700 btn-active-color-primary'
          >
            Back
          </button>
          {/*end::Secondary button*/}
        </div>
        {/*end::Actions*/}
      </div>
      {/*end::Toolbar container*/}
    </div>
  )
}

export {DefaultTitle}
